import React from "react"

import ConceptMappingItem from "./ConceptMappingItem"
import ContentLoaderTags from "../content-loading/ContentLoaderTags"

const ConceptMappingsViewWidget = ({ mappings, isFetching }) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-concepts" />
            Mappings
        </h3>
        <div className="widget-content">
            <div className="mapping-box">
                <ContentLoaderTags
                    isFetching={isFetching}
                    minLines={2}
                    maxLines={5}
                >
                    {mappings.map(mapping => (
                        <ConceptMappingItem key={mapping.id} {...mapping} />
                    ))}
                    {mappings.length === 0 && "No mappings"}
                </ContentLoaderTags>
            </div>
        </div>
    </div>
)

export default ConceptMappingsViewWidget
